import { displayLabel } from '../engine/localize';
import type { CompileResult } from '../engine/types';
import { useI18n } from '../i18n';

/** A row's label: the pattern's own words (marked up as pattern text) or the engine's, in the UI language. */
export function RowLabel({ lineNo, label, result, className = '' }: { lineNo: number; label: string; result: CompileResult; className?: string }) {
  const { lang } = useI18n();
  const d = displayLabel(lineNo, label, result, lang) ?? { text: label, quoted: false };
  return (
    <span className={className} data-verbatim={d.quoted || undefined} lang={d.quoted ? result.document.lang : undefined}>
      {d.text}
    </span>
  );
}
